import { CandidateAvailabilityStorage } from '../storage';

export const getOnboardingAutostartActive = () => {
    const pageVisited = CandidateAvailabilityStorage.getInstance().getTimeSlotsPageVisited();

    return !pageVisited;
};
